import React from 'react';
import { Icon } from '../../elements/icon';

const OptionCard = ({ label, icon, isSelected, isMulti, onClick, className = '' }) => {
  const baseCard =
    't-w-full t-flex t-items-center t-gap-3 t-px-4 t-py-3.5 t-border-2 t-rounded-xl t-bg-white t-cursor-pointer t-text-left t-font-sans t-text-[14.5px] t-font-medium t-text-navy t-outline-none t-min-h-[52px] t-transition-[background-color,border-color,box-shadow,transform] t-duration-200 t-ease-out';
  const hoverCard =
    '[@media(hover:hover)]:hover:t-border-quiz-teal/25 [@media(hover:hover)]:hover:t-bg-quiz-teal/[.07]';
  const activeCard = 'active:t-scale-[.988]';
  const selectedCard = isSelected
    ? 't-border-quiz-teal t-bg-quiz-teal/[.07] t-shadow-[0_0_0_1px_#116D6E]'
    : 't-border-g200';

  const checkBase =
    't-w-5 t-h-5 t-min-w-[20px] t-flex t-items-center t-justify-center t-border-2 t-transition-all t-duration-150';
  const checkShape = isMulti ? 't-rounded-[5px]' : 't-rounded-full';
  const checkColor = isSelected ? 't-border-quiz-teal t-bg-quiz-teal' : 't-border-g300 t-bg-transparent';

  return (
    <button
      type="button"
      className={`${baseCard} ${hoverCard} ${activeCard} ${selectedCard} ${className}`}
      onClick={onClick}
    >
      <div className={`${checkBase} ${checkShape} ${checkColor}`}>
        <Icon
          name="tick"
          size={11}
          color="#fff"
          raw
          className={isSelected ? 't-opacity-100' : 't-opacity-0'}
        />
      </div>
      <span dangerouslySetInnerHTML={{ __html: label }} />
      {icon && <span className="t-text-lg t-w-6 t-text-center">{icon}</span>}
    </button>
  );
};

export default React.memo(OptionCard);
